module.exports = __webpack_public_path__ + "img/Menu-09.874464a7.png";